const state = {
  menuSectionIndex: -1,
  isQSIframeLoaded: false,
}

const actions = {
  setMenuSectionIndex({commit}, currentIndex = 0) {
    commit('setMenuSectionIndex', currentIndex)
  },
  setQsIFrameLoaded({commit}, isQSIframeLoaded) {
    commit('setQsIFrameLoaded', isQSIframeLoaded)
  },
}

const mutations = {
  setMenuSectionIndex(state, currentIndex) {
    state.menuSectionIndex = currentIndex
  },
  setQsIFrameLoaded(state, isQSIframeLoaded) {
    state.isQSIframeLoaded = isQSIframeLoaded
  },
}

const getters = {
  getMenuSectionIndex: (state) => {
    return state.menuSectionIndex
  },
  getIsQSIframeLoaded: state => state.isQSIframeLoaded,
}

export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters
}